import React from "react";
import {
  BrowserRouter as Router,
  Routes ,
  Route
} from "react-router-dom";


import Topics from "./topics/Topics";
import TopicsTemplates from "./topics/TopicsTemplates";
import ExamTemplates from "./exams/ExamTemplates";
import QtTemplates from "./QuestionTypes/QtTemplates";
import QuestionTypesList from "./QuestionTypes/QuestionTypesList"; 
import ExamLimitObjective from "./exams/ExamLimitObjective";
import ExamLimitSubjective from "./exams/ExamLimitSubjective";
import SelftestOptions from "./SelftestOptions/SelftestOptionsObj";
import SelftestOptionsSub from "./SelftestOptions/SelftestOptionsSub";
import TestPatterns from "./TestPattern/TestPatterns"; 
import TestPatternSectionz from "./TestPattern/TestPatternSectionz";
import TestPatternDefinationz from "./TestPattern/TestPatternDefinationz";
import MocktestTemplates from "./MocktestTemplates/MocktestTemplates";
import MocktestCategoryz from "./MocktestTemplates/MocktestCategoryz";
import MocktestMgmtz from "./MocktestTemplates/MocktestMgmtz";
import TopictestTemplates from "./TopictestTemps/TopictestTemplates"; 
import QuestionBanks from "./questionbank/QuestionBanks"; 
import QuestionsUpload from "./questionbank/QuestionsUpload";
import QuestionsCounterAll from "./questionbank/QuestionsCounterAll";
import QuestionsDownload from "./questionbank/QuestionsDownload";
///import QBSanitization from "./questionbank/QBSanitization";
import Grades from "./grades/Grades";
import DifficultyList from "./difficulty/DifficultyList";
import KeywordsList from "./keywords/KeywordsList";
import TagsList from "./tags/TagsList";
import Languages from "./languages/Languages";

import ContentLimits from "./contentlimit/ContentLimits";

import TopicContents from "./smartlearning/TopicContents";
// import KeywordContents from "./smartlearning/KeywordContents";

import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Login from "./pages/Login";

import Subjects from "./subject/Subjects"; 
import Users from "./pages/Users";
import Roles from "./pages/Roles";

///import TestingOne from "./topics/TestingOne";


const getBasename = () => {
  ///return '/'+process.env.PUBLIC_URL.split('/').pop();
  ///return "/reacteasetolearn";
  return "";
};

function App() {

  return (
    <Router basename={getBasename()} >
      <div>
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Routes>         
          {/* <Route exact path="/keyword-contents" element={<KeywordContents/>} /> */}
          <Route exact path="/topic-contents" element={<TopicContents/>} />  
    
          <Route exact path="/languages" element={<Languages/>} />
          <Route exact path="/difficulty" element={<DifficultyList/>} />
          <Route exact path="/keywords" element={<KeywordsList/>} />
          <Route exact path="/tags" element={<TagsList/>} />
          <Route exact path="/grades" element={<Grades/>} />
          <Route exact path="/subjects" element={<Subjects/>} />
          <Route exact path="/topics" element={<Topics/>} />
          
          <Route exact path="/topics-templates" element={<TopicsTemplates/>} />
          {/* <Route exact path="/testingone" element={<TestingOne/>} /> */}

          <Route exact path="/qt-templates" element={<QtTemplates/>} />
          <Route exact path="/question-types" element={<QuestionTypesList/>} />
          <Route exact path="/exam-limit-objective" element={<ExamLimitObjective/>} />
          <Route exact path="/exam-limit-subjective" element={<ExamLimitSubjective/>} />
          <Route exact path="/selftest-options-objective" element={<SelftestOptions/>} />
          <Route exact path="/selftest-options-subjective" element={<SelftestOptionsSub/>} />

          <Route exact path="/exam-templates" element={<ExamTemplates/>} />

          <Route exact path="/content-limits" element={<ContentLimits/>} />
          
          <Route exact path="/test-patterns" element={<TestPatterns/>} />
          <Route exact path="/test-pattern-section" element={<TestPatternSectionz/>} />
          <Route exact path="/test-pattern-defination" element={<TestPatternDefinationz/>} />

          <Route exact path="/mocktest-templates" element={<MocktestTemplates/>} />
          <Route exact path="/mocktest-category" element={<MocktestCategoryz/>} />
          <Route exact path="/mocktest-mgmt" element={<MocktestMgmtz/>} />


          <Route exact path="/topictest-templates" element={<TopictestTemplates/>} />
          
          <Route exact path="/subjects" element={<Subjects/>} />
          <Route exact path="/users" element={<Users/>} />
          <Route exact path="/roles" element={<Roles/>} />

          <Route exact path="/questions-upload" element={<QuestionsUpload/>} />
          <Route exact path="/questions-download" element={<QuestionsDownload/>} />
          <Route exact path="/question-bank" element={<QuestionBanks/>} />
          <Route exact path="/question-chart-allcounter" element={<QuestionsCounterAll/>} />
          {/* <Route exact path="/qb-sanitization" element={<QBSanitization/>} /> */}

          <Route exact path="/forgotpassword" element={<ForgotPassword/>} />
          <Route exact path="/resetpassword" element={<ResetPassword/>} />  

          
          <Route exact path="/login" element={<Login />} />  
          <Route exact path="/" element={<Login />} />  
          
          
        </Routes >
      </div>
    </Router>
  );
}

export default App;
